<template>
  <el-dialog :title="answer.type === 'text'? '修改答案':'更新链接'" v-if="dialogVisible" :visible.sync="dialogVisible"
             width="50%" @close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="form" ref="form">
      <el-form-item v-if="answer.type ==='text'" label="答案">
        <quill-editor :value.sync="answer.content"
                      style="margin-bottom:10px !important"></quill-editor>
      </el-form-item>
      <el-form-item v-if="answer.type ==='link'" label="链接" prop="link">
        <el-input v-model="answer.link"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose(false)">{{ specialTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="submitForm()" :disabled="pending">{{ specialTextConfig.ok }}</el-button>
        </span>
  </el-dialog>
</template>

<script>
import quillEditor from '@/components/editor/index.vue'
import {modifyAnswer} from "@/api/exam"

export default {
  props: ['answer', 'show'],
  components: {
    quillEditor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: null,
        subQuestionIndex: null,
        answer: null,
        link: null,
      },
      pending: false
    };
  },
  computed: {
    specialTextConfig() {
      return this.$store.state.global.textConfig.backend.examineeScore.table.button.special
    },
  },
  watch: {
    show() {
      this.dialogVisible = this.show;
    },
  },
  methods: {
    handleClose(refresh) {
      this.dialogVisible = false;
      this.form.answer = null;
      this.form.id = null;
      this.form.subQuestionIndex = null;
      this.form.link = null;
      this.$emit('close', refresh)
    },
    submitForm() {
      this.pending = true
      this.form.id = this.answer.id
      this.form.subQuestionIndex = this.answer.subQuestionIndex

      this.form.answer = this.answer.content;
      this.form.link = this.answer.link;
      modifyAnswer(this.form).then(res => {
        this.pending = false;
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '答案修改成功'
          });
          this.handleClose(true)
        }
      }).catch(() => {
        this.pending = false;
      });
    }
  }
}
</script>
